import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  border: "1px",
  class: "item-table"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { width: "20%" }, " Type "),
    /*#__PURE__*/_createElementVNode("th", { width: "20%" }, " Weight "),
    /*#__PURE__*/_createElementVNode("th", { width: "20%" }, " Price "),
    /*#__PURE__*/_createElementVNode("th", { width: "20%" }, " Name "),
    /*#__PURE__*/_createElementVNode("th", { width: "20%" })
  ])
], -1)
const _hoisted_4 = ["onUpdate:modelValue"]
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  colspan: "5",
  style: {"text-align":"right"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Datepicker, {
      modelValue: _ctx.calendarDate,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.calendarDate) = $event)),
        _ctx.handleDate
      ],
      "enable-time-picker": false,
      placeholder: "วันที่",
      format: "dd/MM/yyyy",
      "text-input": "",
      "auto-apply": ""
    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.id,
            class: "itemList"
          }, [
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((item.type) = $event),
                type: "text",
                disabled: ""
              }, null, 8, _hoisted_4), [
                [_vModelText, item.type]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((item.weight) = $event),
                type: "number",
                disabled: ""
              }, null, 8, _hoisted_5), [
                [_vModelText, item.weight]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((item.price) = $event),
                type: "number",
                disabled: ""
              }, null, 8, _hoisted_6), [
                [_vModelText, item.price]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                type: "text",
                disabled: ""
              }, null, 8, _hoisted_7), [
                [_vModelText, item.name]
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.onDeleteItem(item.id))
              }, " ลบ ", 8, _hoisted_8)
            ])
          ]))
        }), 128)),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newItem.type) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemTypes, (type) => {
                return (_openBlock(), _createElementBlock("option", { key: type }, _toDisplayString(type.name), 1))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.newItem.type]
            ])
          ]),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newItem.weight) = $event)),
              type: "number"
            }, null, 512), [
              [_vModelText, _ctx.newItem.weight]
            ])
          ]),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newItem.price) = $event)),
              type: "number"
            }, null, 512), [
              [_vModelText, _ctx.newItem.price]
            ])
          ]),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newItem.name) = $event)),
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.newItem.name]
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSubmitItem && _ctx.onSubmitItem(...args)))
            }, " เพิ่ม ")
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_9, " sum: " + _toDisplayString(_ctx.sumItemPrice), 1)
        ])
      ])
    ])
  ]))
}